import { __extends } from "tslib";
import { BatchExecuteStatementCommand } from "./commands/BatchExecuteStatementCommand";
import { BatchGetItemCommand } from "./commands/BatchGetItemCommand";
import { BatchWriteItemCommand } from "./commands/BatchWriteItemCommand";
import { CreateBackupCommand } from "./commands/CreateBackupCommand";
import { CreateGlobalTableCommand } from "./commands/CreateGlobalTableCommand";
import { CreateTableCommand } from "./commands/CreateTableCommand";
import { DeleteBackupCommand } from "./commands/DeleteBackupCommand";
import { DeleteItemCommand } from "./commands/DeleteItemCommand";
import { DeleteTableCommand } from "./commands/DeleteTableCommand";
import { DescribeBackupCommand } from "./commands/DescribeBackupCommand";
import { DescribeContinuousBackupsCommand } from "./commands/DescribeContinuousBackupsCommand";
import { DescribeContributorInsightsCommand } from "./commands/DescribeContributorInsightsCommand";
import { DescribeEndpointsCommand } from "./commands/DescribeEndpointsCommand";
import { DescribeExportCommand } from "./commands/DescribeExportCommand";
import { DescribeGlobalTableCommand } from "./commands/DescribeGlobalTableCommand";
import { DescribeGlobalTableSettingsCommand } from "./commands/DescribeGlobalTableSettingsCommand";
import { DescribeKinesisStreamingDestinationCommand } from "./commands/DescribeKinesisStreamingDestinationCommand";
import { DescribeLimitsCommand } from "./commands/DescribeLimitsCommand";
import { DescribeTableCommand } from "./commands/DescribeTableCommand";
import { DescribeTableReplicaAutoScalingCommand } from "./commands/DescribeTableReplicaAutoScalingCommand";
import { DescribeTimeToLiveCommand } from "./commands/DescribeTimeToLiveCommand";
import { DisableKinesisStreamingDestinationCommand } from "./commands/DisableKinesisStreamingDestinationCommand";
import { EnableKinesisStreamingDestinationCommand } from "./commands/EnableKinesisStreamingDestinationCommand";
import { ExecuteStatementCommand } from "./commands/ExecuteStatementCommand";
import { ExecuteTransactionCommand } from "./commands/ExecuteTransactionCommand";
import { ExportTableToPointInTimeCommand } from "./commands/ExportTableToPointInTimeCommand";
import { GetItemCommand } from "./commands/GetItemCommand";
import { ListBackupsCommand } from "./commands/ListBackupsCommand";
import { ListContributorInsightsCommand } from "./commands/ListContributorInsightsCommand";
import { ListExportsCommand } from "./commands/ListExportsCommand";
import { ListGlobalTablesCommand } from "./commands/ListGlobalTablesCommand";
import { ListTablesCommand } from "./commands/ListTablesCommand";
import { ListTagsOfResourceCommand } from "./commands/ListTagsOfResourceCommand";
import { PutItemCommand } from "./commands/PutItemCommand";
import { QueryCommand } from "./commands/QueryCommand";
import { RestoreTableFromBackupCommand } from "./commands/RestoreTableFromBackupCommand";
import { RestoreTableToPointInTimeCommand } from "./commands/RestoreTableToPointInTimeCommand";
import { ScanCommand } from "./commands/ScanCommand";
import { TagResourceCommand } from "./commands/TagResourceCommand";
import { TransactGetItemsCommand } from "./commands/TransactGetItemsCommand";
import { TransactWriteItemsCommand } from "./commands/TransactWriteItemsCommand";
import { UntagResourceCommand } from "./commands/UntagResourceCommand";
import { UpdateContinuousBackupsCommand } from "./commands/UpdateContinuousBackupsCommand";
import { UpdateContributorInsightsCommand } from "./commands/UpdateContributorInsightsCommand";
import { UpdateGlobalTableCommand } from "./commands/UpdateGlobalTableCommand";
import { UpdateGlobalTableSettingsCommand } from "./commands/UpdateGlobalTableSettingsCommand";
import { UpdateItemCommand } from "./commands/UpdateItemCommand";
import { UpdateTableCommand } from "./commands/UpdateTableCommand";
import { UpdateTableReplicaAutoScalingCommand } from "./commands/UpdateTableReplicaAutoScalingCommand";
import { UpdateTimeToLiveCommand } from "./commands/UpdateTimeToLiveCommand";
import { DynamoDBClient } from "./DynamoDBClient";

var DynamoDB = function (_super) {
  __extends(DynamoDB, _super);

  function DynamoDB() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  DynamoDB.prototype.batchExecuteStatement = function (args, optionsOrCb, cb) {
    var command = new BatchExecuteStatementCommand(args);

    if (typeof optionsOrCb === "function") {
      this.send(command, optionsOrCb);
    } else if (typeof cb === "function") {
      if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get ".concat(typeof optionsOrCb));
      this.send(command, optionsOrCb || {}, cb);
    } else {
      return this.send(command, optionsOrCb);
    }
  };

  DynamoDB.prototype.batchGetItem = function (args, optionsOrCb, cb) {
    var command = new BatchGetItemCommand(args);

    if (typeof optionsOrCb === "function") {
      this.send(command, optionsOrCb);
    } else if (typeof cb === "function") {
      if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get ".concat(typeof optionsOrCb));
      this.send(command, optionsOrCb || {}, cb);
    } else {
      return this.send(command, optionsOrCb);
    }
  };

  DynamoDB.prototype.batchWriteItem = function (args, optionsOrCb, cb) {
    var command = new BatchWriteItemCommand(args);

    if (typeof optionsOrCb === "function") {
      this.send(command, optionsOrCb);
    } else if (typeof cb === "function") {
      if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get ".concat(typeof optionsOrCb));
      this.send(command, optionsOrCb || {}, cb);
    } else {
      return this.send(command, optionsOrCb);
    }
  };

  DynamoDB.prototype.createBackup = function (args, optionsOrCb, cb) {
    var command = new CreateBackupCommand(args);

    if (typeof optionsOrCb === "function") {
      this.send(command, optionsOrCb);
    } else if (typeof cb === "function") {
      if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get ".concat(typeof optionsOrCb));
      this.send(command, optionsOrCb || {}, cb);
    } else {
      return this.send(command, optionsOrCb);
    }
  };

  DynamoDB.prototype.createGlobalTable = function (args, optionsOrCb, cb) {
    var command = new CreateGlobalTableCommand(args);

    if (typeof optionsOrCb === "function") {
      this.send(command, optionsOrCb);
    } else if (typeof cb === "function") {
      if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get ".concat(typeof optionsOrCb));
      this.send(command, optionsOrCb || {}, cb);
    } else {
      return this.send(command, optionsOrCb);
    }
  };

  DynamoDB.prototype.createTable = function (args, optionsOrCb, cb) {
    var command = new CreateTableCommand(args);

    if (typeof optionsOrCb === "function") {
      this.send(command, optionsOrCb);
    } else if (typeof cb === "function") {
      if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get ".concat(typeof optionsOrCb));
      this.send(command, optionsOrCb || {}, cb);
    } else {
      return this.send(command, optionsOrCb);
    }
  };

  DynamoDB.prototype.deleteBackup = function (args, optionsOrCb, cb) {
    var command = new DeleteBackupCommand(args);

    if (typeof optionsOrCb === "function") {
      this.send(command, optionsOrCb);
    } else if (typeof cb === "function") {
      if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get ".concat(typeof optionsOrCb));
      this.send(command, optionsOrCb || {}, cb);
    } else {
      return this.send(command, optionsOrCb);
    }
  };

  DynamoDB.prototype.deleteItem = function (args, optionsOrCb, cb) {
    var command = new DeleteItemCommand(args);

    if (typeof optionsOrCb === "function") {
      this.send(command, optionsOrCb);
    } else if (typeof cb === "function") {
      if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get ".concat(typeof optionsOrCb));
      this.send(command, optionsOrCb || {}, cb);
    } else {
      return this.send(command, optionsOrCb);
    }
  };

  DynamoDB.prototype.deleteTable = function (args, optionsOrCb, cb) {
    var command = new DeleteTableCommand(args);

    if (typeof optionsOrCb === "function") {
      this.send(command, optionsOrCb);
    } else if (typeof cb === "function") {
      if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get ".concat(typeof optionsOrCb));
      this.send(command, optionsOrCb || {}, cb);
    } else {
      return this.send(command, optionsOrCb);
    }
  };

  DynamoDB.prototype.describeBackup = function (args, optionsOrCb, cb) {
    var command = new DescribeBackupCommand(args);

    if (typeof optionsOrCb === "function") {
      this.send(command, optionsOrCb);
    } else if (typeof cb === "function") {
      if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get ".concat(typeof optionsOrCb));
      this.send(command, optionsOrCb || {}, cb);
    } else {
      return this.send(command, optionsOrCb);
    }
  };

  DynamoDB.prototype.describeContinuousBackups = function (args, optionsOrCb, cb) {
    var command = new DescribeContinuousBackupsCommand(args);

    if (typeof optionsOrCb === "function") {
      this.send(command, optionsOrCb);
    } else if (typeof cb === "function") {
      if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get ".concat(typeof optionsOrCb));
      this.send(command, optionsOrCb || {}, cb);
    } else {
      return this.send(command, optionsOrCb);
    }
  };

  DynamoDB.prototype.describeContributorInsights = function (args, optionsOrCb, cb) {
    var command = new DescribeContributorInsightsCommand(args);

    if (typeof optionsOrCb === "function") {
      this.send(command, optionsOrCb);
    } else if (typeof cb === "function") {
      if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get ".concat(typeof optionsOrCb));
      this.send(command, optionsOrCb || {}, cb);
    } else {
      return this.send(command, optionsOrCb);
    }
  };

  DynamoDB.prototype.describeEndpoints = function (args, optionsOrCb, cb) {
    var command = new DescribeEndpointsCommand(args);

    if (typeof optionsOrCb === "function") {
      this.send(command, optionsOrCb);
    } else if (typeof cb === "function") {
      if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get ".concat(typeof optionsOrCb));
      this.send(command, optionsOrCb || {}, cb);
    } else {
      return this.send(command, optionsOrCb);
    }
  };

  DynamoDB.prototype.describeExport = function (args, optionsOrCb, cb) {
    var command = new DescribeExportCommand(args);

    if (typeof optionsOrCb === "function") {
      this.send(command, optionsOrCb);
    } else if (typeof cb === "function") {
      if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get ".concat(typeof optionsOrCb));
      this.send(command, optionsOrCb || {}, cb);
    } else {
      return this.send(command, optionsOrCb);
    }
  };

  DynamoDB.prototype.describeGlobalTable = function (args, optionsOrCb, cb) {
    var command = new DescribeGlobalTableCommand(args);

    if (typeof optionsOrCb === "function") {
      this.send(command, optionsOrCb);
    } else if (typeof cb === "function") {
      if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get ".concat(typeof optionsOrCb));
      this.send(command, optionsOrCb || {}, cb);
    } else {
      return this.send(command, optionsOrCb);
    }
  };

  DynamoDB.prototype.describeGlobalTableSettings = function (args, optionsOrCb, cb) {
    var command = new DescribeGlobalTableSettingsCommand(args);

    if (typeof optionsOrCb === "function") {
      this.send(command, optionsOrCb);
    } else if (typeof cb === "function") {
      if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get ".concat(typeof optionsOrCb));
      this.send(command, optionsOrCb || {}, cb);
    } else {
      return this.send(command, optionsOrCb);
    }
  };

  DynamoDB.prototype.describeKinesisStreamingDestination = function (args, optionsOrCb, cb) {
    var command = new DescribeKinesisStreamingDestinationCommand(args);

    if (typeof optionsOrCb === "function") {
      this.send(command, optionsOrCb);
    } else if (typeof cb === "function") {
      if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get ".concat(typeof optionsOrCb));
      this.send(command, optionsOrCb || {}, cb);
    } else {
      return this.send(command, optionsOrCb);
    }
  };

  DynamoDB.prototype.describeLimits = function (args, optionsOrCb, cb) {
    var command = new DescribeLimitsCommand(args);

    if (typeof optionsOrCb === "function") {
      this.send(command, optionsOrCb);
    } else if (typeof cb === "function") {
      if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get ".concat(typeof optionsOrCb));
      this.send(command, optionsOrCb || {}, cb);
    } else {
      return this.send(command, optionsOrCb);
    }
  };

  DynamoDB.prototype.describeTable = function (args, optionsOrCb, cb) {
    var command = new DescribeTableCommand(args);

    if (typeof optionsOrCb === "function") {
      this.send(command, optionsOrCb);
    } else if (typeof cb === "function") {
      if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get ".concat(typeof optionsOrCb));
      this.send(command, optionsOrCb || {}, cb);
    } else {
      return this.send(command, optionsOrCb);
    }
  };

  DynamoDB.prototype.describeTableReplicaAutoScaling = function (args, optionsOrCb, cb) {
    var command = new DescribeTableReplicaAutoScalingCommand(args);

    if (typeof optionsOrCb === "function") {
      this.send(command, optionsOrCb);
    } else if (typeof cb === "function") {
      if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get ".concat(typeof optionsOrCb));
      this.send(command, optionsOrCb || {}, cb);
    } else {
      return this.send(command, optionsOrCb);
    }
  };

  DynamoDB.prototype.describeTimeToLive = function (args, optionsOrCb, cb) {
    var command = new DescribeTimeToLiveCommand(args);

    if (typeof optionsOrCb === "function") {
      this.send(command, optionsOrCb);
    } else if (typeof cb === "function") {
      if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get ".concat(typeof optionsOrCb));
      this.send(command, optionsOrCb || {}, cb);
    } else {
      return this.send(command, optionsOrCb);
    }
  };

  DynamoDB.prototype.disableKinesisStreamingDestination = function (args, optionsOrCb, cb) {
    var command = new DisableKinesisStreamingDestinationCommand(args);

    if (typeof optionsOrCb === "function") {
      this.send(command, optionsOrCb);
    } else if (typeof cb === "function") {
      if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get ".concat(typeof optionsOrCb));
      this.send(command, optionsOrCb || {}, cb);
    } else {
      return this.send(command, optionsOrCb);
    }
  };

  DynamoDB.prototype.enableKinesisStreamingDestination = function (args, optionsOrCb, cb) {
    var command = new EnableKinesisStreamingDestinationCommand(args);

    if (typeof optionsOrCb === "function") {
      this.send(command, optionsOrCb);
    } else if (typeof cb === "function") {
      if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get ".concat(typeof optionsOrCb));
      this.send(command, optionsOrCb || {}, cb);
    } else {
      return this.send(command, optionsOrCb);
    }
  };

  DynamoDB.prototype.executeStatement = function (args, optionsOrCb, cb) {
    var command = new ExecuteStatementCommand(args);

    if (typeof optionsOrCb === "function") {
      this.send(command, optionsOrCb);
    } else if (typeof cb === "function") {
      if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get ".concat(typeof optionsOrCb));
      this.send(command, optionsOrCb || {}, cb);
    } else {
      return this.send(command, optionsOrCb);
    }
  };

  DynamoDB.prototype.executeTransaction = function (args, optionsOrCb, cb) {
    var command = new ExecuteTransactionCommand(args);

    if (typeof optionsOrCb === "function") {
      this.send(command, optionsOrCb);
    } else if (typeof cb === "function") {
      if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get ".concat(typeof optionsOrCb));
      this.send(command, optionsOrCb || {}, cb);
    } else {
      return this.send(command, optionsOrCb);
    }
  };

  DynamoDB.prototype.exportTableToPointInTime = function (args, optionsOrCb, cb) {
    var command = new ExportTableToPointInTimeCommand(args);

    if (typeof optionsOrCb === "function") {
      this.send(command, optionsOrCb);
    } else if (typeof cb === "function") {
      if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get ".concat(typeof optionsOrCb));
      this.send(command, optionsOrCb || {}, cb);
    } else {
      return this.send(command, optionsOrCb);
    }
  };

  DynamoDB.prototype.getItem = function (args, optionsOrCb, cb) {
    var command = new GetItemCommand(args);

    if (typeof optionsOrCb === "function") {
      this.send(command, optionsOrCb);
    } else if (typeof cb === "function") {
      if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get ".concat(typeof optionsOrCb));
      this.send(command, optionsOrCb || {}, cb);
    } else {
      return this.send(command, optionsOrCb);
    }
  };

  DynamoDB.prototype.listBackups = function (args, optionsOrCb, cb) {
    var command = new ListBackupsCommand(args);

    if (typeof optionsOrCb === "function") {
      this.send(command, optionsOrCb);
    } else if (typeof cb === "function") {
      if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get ".concat(typeof optionsOrCb));
      this.send(command, optionsOrCb || {}, cb);
    } else {
      return this.send(command, optionsOrCb);
    }
  };

  DynamoDB.prototype.listContributorInsights = function (args, optionsOrCb, cb) {
    var command = new ListContributorInsightsCommand(args);

    if (typeof optionsOrCb === "function") {
      this.send(command, optionsOrCb);
    } else if (typeof cb === "function") {
      if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get ".concat(typeof optionsOrCb));
      this.send(command, optionsOrCb || {}, cb);
    } else {
      return this.send(command, optionsOrCb);
    }
  };

  DynamoDB.prototype.listExports = function (args, optionsOrCb, cb) {
    var command = new ListExportsCommand(args);

    if (typeof optionsOrCb === "function") {
      this.send(command, optionsOrCb);
    } else if (typeof cb === "function") {
      if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get ".concat(typeof optionsOrCb));
      this.send(command, optionsOrCb || {}, cb);
    } else {
      return this.send(command, optionsOrCb);
    }
  };

  DynamoDB.prototype.listGlobalTables = function (args, optionsOrCb, cb) {
    var command = new ListGlobalTablesCommand(args);

    if (typeof optionsOrCb === "function") {
      this.send(command, optionsOrCb);
    } else if (typeof cb === "function") {
      if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get ".concat(typeof optionsOrCb));
      this.send(command, optionsOrCb || {}, cb);
    } else {
      return this.send(command, optionsOrCb);
    }
  };

  DynamoDB.prototype.listTables = function (args, optionsOrCb, cb) {
    var command = new ListTablesCommand(args);

    if (typeof optionsOrCb === "function") {
      this.send(command, optionsOrCb);
    } else if (typeof cb === "function") {
      if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get ".concat(typeof optionsOrCb));
      this.send(command, optionsOrCb || {}, cb);
    } else {
      return this.send(command, optionsOrCb);
    }
  };

  DynamoDB.prototype.listTagsOfResource = function (args, optionsOrCb, cb) {
    var command = new ListTagsOfResourceCommand(args);

    if (typeof optionsOrCb === "function") {
      this.send(command, optionsOrCb);
    } else if (typeof cb === "function") {
      if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get ".concat(typeof optionsOrCb));
      this.send(command, optionsOrCb || {}, cb);
    } else {
      return this.send(command, optionsOrCb);
    }
  };

  DynamoDB.prototype.putItem = function (args, optionsOrCb, cb) {
    var command = new PutItemCommand(args);

    if (typeof optionsOrCb === "function") {
      this.send(command, optionsOrCb);
    } else if (typeof cb === "function") {
      if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get ".concat(typeof optionsOrCb));
      this.send(command, optionsOrCb || {}, cb);
    } else {
      return this.send(command, optionsOrCb);
    }
  };

  DynamoDB.prototype.query = function (args, optionsOrCb, cb) {
    var command = new QueryCommand(args);

    if (typeof optionsOrCb === "function") {
      this.send(command, optionsOrCb);
    } else if (typeof cb === "function") {
      if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get ".concat(typeof optionsOrCb));
      this.send(command, optionsOrCb || {}, cb);
    } else {
      return this.send(command, optionsOrCb);
    }
  };

  DynamoDB.prototype.restoreTableFromBackup = function (args, optionsOrCb, cb) {
    var command = new RestoreTableFromBackupCommand(args);

    if (typeof optionsOrCb === "function") {
      this.send(command, optionsOrCb);
    } else if (typeof cb === "function") {
      if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get ".concat(typeof optionsOrCb));
      this.send(command, optionsOrCb || {}, cb);
    } else {
      return this.send(command, optionsOrCb);
    }
  };

  DynamoDB.prototype.restoreTableToPointInTime = function (args, optionsOrCb, cb) {
    var command = new RestoreTableToPointInTimeCommand(args);

    if (typeof optionsOrCb === "function") {
      this.send(command, optionsOrCb);
    } else if (typeof cb === "function") {
      if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get ".concat(typeof optionsOrCb));
      this.send(command, optionsOrCb || {}, cb);
    } else {
      return this.send(command, optionsOrCb);
    }
  };

  DynamoDB.prototype.scan = function (args, optionsOrCb, cb) {
    var command = new ScanCommand(args);

    if (typeof optionsOrCb === "function") {
      this.send(command, optionsOrCb);
    } else if (typeof cb === "function") {
      if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get ".concat(typeof optionsOrCb));
      this.send(command, optionsOrCb || {}, cb);
    } else {
      return this.send(command, optionsOrCb);
    }
  };

  DynamoDB.prototype.tagResource = function (args, optionsOrCb, cb) {
    var command = new TagResourceCommand(args);

    if (typeof optionsOrCb === "function") {
      this.send(command, optionsOrCb);
    } else if (typeof cb === "function") {
      if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get ".concat(typeof optionsOrCb));
      this.send(command, optionsOrCb || {}, cb);
    } else {
      return this.send(command, optionsOrCb);
    }
  };

  DynamoDB.prototype.transactGetItems = function (args, optionsOrCb, cb) {
    var command = new TransactGetItemsCommand(args);

    if (typeof optionsOrCb === "function") {
      this.send(command, optionsOrCb);
    } else if (typeof cb === "function") {
      if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get ".concat(typeof optionsOrCb));
      this.send(command, optionsOrCb || {}, cb);
    } else {
      return this.send(command, optionsOrCb);
    }
  };

  DynamoDB.prototype.transactWriteItems = function (args, optionsOrCb, cb) {
    var command = new TransactWriteItemsCommand(args);

    if (typeof optionsOrCb === "function") {
      this.send(command, optionsOrCb);
    } else if (typeof cb === "function") {
      if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get ".concat(typeof optionsOrCb));
      this.send(command, optionsOrCb || {}, cb);
    } else {
      return this.send(command, optionsOrCb);
    }
  };

  DynamoDB.prototype.untagResource = function (args, optionsOrCb, cb) {
    var command = new UntagResourceCommand(args);

    if (typeof optionsOrCb === "function") {
      this.send(command, optionsOrCb);
    } else if (typeof cb === "function") {
      if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get ".concat(typeof optionsOrCb));
      this.send(command, optionsOrCb || {}, cb);
    } else {
      return this.send(command, optionsOrCb);
    }
  };

  DynamoDB.prototype.updateContinuousBackups = function (args, optionsOrCb, cb) {
    var command = new UpdateContinuousBackupsCommand(args);

    if (typeof optionsOrCb === "function") {
      this.send(command, optionsOrCb);
    } else if (typeof cb === "function") {
      if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get ".concat(typeof optionsOrCb));
      this.send(command, optionsOrCb || {}, cb);
    } else {
      return this.send(command, optionsOrCb);
    }
  };

  DynamoDB.prototype.updateContributorInsights = function (args, optionsOrCb, cb) {
    var command = new UpdateContributorInsightsCommand(args);

    if (typeof optionsOrCb === "function") {
      this.send(command, optionsOrCb);
    } else if (typeof cb === "function") {
      if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get ".concat(typeof optionsOrCb));
      this.send(command, optionsOrCb || {}, cb);
    } else {
      return this.send(command, optionsOrCb);
    }
  };

  DynamoDB.prototype.updateGlobalTable = function (args, optionsOrCb, cb) {
    var command = new UpdateGlobalTableCommand(args);

    if (typeof optionsOrCb === "function") {
      this.send(command, optionsOrCb);
    } else if (typeof cb === "function") {
      if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get ".concat(typeof optionsOrCb));
      this.send(command, optionsOrCb || {}, cb);
    } else {
      return this.send(command, optionsOrCb);
    }
  };

  DynamoDB.prototype.updateGlobalTableSettings = function (args, optionsOrCb, cb) {
    var command = new UpdateGlobalTableSettingsCommand(args);

    if (typeof optionsOrCb === "function") {
      this.send(command, optionsOrCb);
    } else if (typeof cb === "function") {
      if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get ".concat(typeof optionsOrCb));
      this.send(command, optionsOrCb || {}, cb);
    } else {
      return this.send(command, optionsOrCb);
    }
  };

  DynamoDB.prototype.updateItem = function (args, optionsOrCb, cb) {
    var command = new UpdateItemCommand(args);

    if (typeof optionsOrCb === "function") {
      this.send(command, optionsOrCb);
    } else if (typeof cb === "function") {
      if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get ".concat(typeof optionsOrCb));
      this.send(command, optionsOrCb || {}, cb);
    } else {
      return this.send(command, optionsOrCb);
    }
  };

  DynamoDB.prototype.updateTable = function (args, optionsOrCb, cb) {
    var command = new UpdateTableCommand(args);

    if (typeof optionsOrCb === "function") {
      this.send(command, optionsOrCb);
    } else if (typeof cb === "function") {
      if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get ".concat(typeof optionsOrCb));
      this.send(command, optionsOrCb || {}, cb);
    } else {
      return this.send(command, optionsOrCb);
    }
  };

  DynamoDB.prototype.updateTableReplicaAutoScaling = function (args, optionsOrCb, cb) {
    var command = new UpdateTableReplicaAutoScalingCommand(args);

    if (typeof optionsOrCb === "function") {
      this.send(command, optionsOrCb);
    } else if (typeof cb === "function") {
      if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get ".concat(typeof optionsOrCb));
      this.send(command, optionsOrCb || {}, cb);
    } else {
      return this.send(command, optionsOrCb);
    }
  };

  DynamoDB.prototype.updateTimeToLive = function (args, optionsOrCb, cb) {
    var command = new UpdateTimeToLiveCommand(args);

    if (typeof optionsOrCb === "function") {
      this.send(command, optionsOrCb);
    } else if (typeof cb === "function") {
      if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get ".concat(typeof optionsOrCb));
      this.send(command, optionsOrCb || {}, cb);
    } else {
      return this.send(command, optionsOrCb);
    }
  };

  return DynamoDB;
}(DynamoDBClient);

export { DynamoDB };